module.exports = __webpack_public_path__ + "img/exit-link-icon.4002d600.svg";